import { useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * The Planner webapp's section wrapper, reproduced: a bold title beside a
 * chevron that rotates -90° when closed, and a body that animates via
 * max-height + opacity rather than unmounting (so table state survives a
 * collapse).
 */
export function CollapsibleSection({
  title,
  defaultOpen = true,
  right,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  right?: ReactNode;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2 text-left"
          aria-expanded={open}
        >
          <ChevronDown
            className={cn(
              "h-[18px] w-[18px] text-muted-foreground transition-transform duration-200",
              !open && "-rotate-90",
            )}
          />
          <h2 className="text-lg font-bold text-foreground">{title}</h2>
        </button>
        {right}
      </div>
      <div
        className={cn(
          "overflow-hidden transition-all duration-200",
          open ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0",
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default CollapsibleSection;
